import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createElementVNode as _$ce, createUnknownComponentVNode as _$cc, className as _$cn, createVNode as _$cv, extend as _$ex, EMPTY_OBJ as _$em } from 'intact-vue-next';
import { directClone, Transition } from 'intact-vue-next';
import { Dropdown, DropdownItem } from '../dropdown';
import { Tooltip } from '../tooltip';
import { Icon } from '../icon';
import { Menu } from './menu';
import { Ellipsis } from '../ellipsis';
import { getRestProps, expandAnimationCallbacks } from '../utils';
import { isNullOrUndefined } from 'intact-shared';
import { makeItemStyles, makeTitleStyles, makeNestedMenuStyles } from './styles';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj,
    _this = this;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var rootMenu = this.rootMenu;
  var _rootMenu$get = rootMenu.get(),
    theme = _rootMenu$get.theme,
    type = _rootMenu$get.type,
    rootDot = _rootMenu$get.dot,
    size = _rootMenu$get.size;
  var _this$get = this.get(),
    children = _this$get.children,
    key = _this$get.key,
    className = _this$get.className,
    disabled = _this$get.disabled,
    dot = _this$get.dot;
  var _rootMenu$highlight = rootMenu.highlight,
    isHighlighted = _rootMenu$highlight.isHighlighted,
    isSelected = _rootMenu$highlight.isSelected;
  var isExpandedKey = this.expanded.isExpanded;
  var isExpanded = isExpandedKey(key);
  var _this$dropdown = this.dropdown(),
    isTopItem = _this$dropdown.isTopItem,
    subMenuVNode = _this$dropdown.subMenuVNode,
    isDropdownMenu = _this$dropdown.isDropdownMenu,
    tooltipContents = _this$dropdown.tooltipContents,
    iconVNode = _this$dropdown.iconVNode,
    titleVNodes = _this$dropdown.titleVNodes,
    position = _this$dropdown.position,
    isCollapse = _this$dropdown.isCollapse;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-menu-item"] = true, _classNameObj[className] = className, _classNameObj[k + "-expanded"] = isExpanded, _classNameObj[k + "-disabled"] = disabled, _classNameObj[k + "-active"] = isSelected(key), _classNameObj[k + "-highlighted"] = isHighlighted(key), _classNameObj[makeItemStyles(k)] = true, _classNameObj);
  var showDot = isTopItem && !iconVNode && isNullOrUndefined(dot) ? rootDot : dot;
  var title = function title(children) {
    var _$cn2;
    return _$ce(2, 'div', [showDot ? _$cc(Icon, {
      'className': _$cn(k + "-menu-dot ion-record")
    }) : undefined, _$ce(2, 'div', _$cc(Ellipsis, {
      'position': 'bottom',
      'children': children
    }), 2, _$cn(k + "-menu-name")), subMenuVNode ? _$cc(Icon, {
      'className': _$cn(k + "-menu-item-arrow ion-arrow-down-b")
    }) : undefined], 0, _$cn((_$cn2 = {}, _$cn2[k + "-menu-item-title"] = true, _$cn2[makeTitleStyles(k)] = true, _$cn2)), {
      'ev-click': _this.onClick.bind(_this, subMenuVNode)
    });
  };
  return _$cv('div', _extends({
    'className': _$cn(classNameObj)
  }, getRestProps(this)), !isDropdownMenu ? [title(titleVNodes), _$cc(Transition, _extends({
    'show': isExpanded,
    'key': 'subMenu'
  }, expandAnimationCallbacks, {
    'children': function () {
      if (subMenuVNode) {
        var _$cn3;
        var paddingLeft = _this.parentMenu.get('_paddingLeft');
        var _makeNestedMenuStyles = makeNestedMenuStyles(k, showDot || !!iconVNode, paddingLeft, size),
          _classname = _makeNestedMenuStyles[0],
          _paddingLeft = _makeNestedMenuStyles[1];
        var _className = _$cn((_$cn3 = {}, _$cn3[_classname] = true, _$cn3[subMenuVNode.className] = subMenuVNode.className, _$cn3[k + "-sub-menu"] = true, _$cn3));
        var clonedVNode = directClone(subMenuVNode);
        clonedVNode.props = _extends({}, clonedVNode.props, {
          className: _className,
          _paddingLeft: _paddingLeft
        });
        clonedVNode.className = _className;
        return clonedVNode;
      }
    }()
  }), 'subMenu')] : !subMenuVNode ? isTopItem && isCollapse ? _$cc(Tooltip, {
    'position': rootMenu.get('type') !== 'horizontal' ? 'right' : 'bottom',
    'theme': rootMenu.get('theme') === 'dark' ? 'dark' : 'light',
    'children': title(iconVNode),
    '$blocks': function ($blocks) {
      var _$blocks = {},
        __$blocks = _$ex({}, $blocks);
      return (_$blocks['content'] = function ($super) {
        return tooltipContents;
      }, __$blocks['content'] = function ($super, data) {
        var block = $blocks['content'];
        var callBlock = function callBlock() {
          return _$blocks['content'].call($this, $super, data);
        };
        return block ? block.call($this, callBlock, data) : callBlock();
      }), __$blocks;
    }.call($this, _$em)
  }) : title(titleVNodes) : [_$cc(Dropdown, {
    'position': position,
    'children': [title(isTopItem && isCollapse ? iconVNode : titleVNodes), subMenuVNode]
  }), _$cc(Transition, _extends({
    'show': isExpanded,
    'key': 'subMenu'
  }, expandAnimationCallbacks), 'subMenu')]);
}
;